module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [(_vm.isShowzbj) ? _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.changezb
    },
    model: {
      value: (_vm.zbradio),
      callback: function($$v) {
        _vm.zbradio = $$v
      },
      expression: "zbradio"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "直播间",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "直播商品库",
      "name": "second"
    }
  })], 1), _vm._v(" "), (_vm.zbradio == 'first') ? _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "直播间标题："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入直播间标题",
      "maxlength": "20"
    },
    model: {
      value: (_vm.zbjbt),
      callback: function($$v) {
        _vm.zbjbt = $$v
      },
      expression: "zbjbt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "开播时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "daterange",
      "title": _vm.valuedate,
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changetimeOne
    },
    model: {
      value: (_vm.valuedate),
      callback: function($$v) {
        _vm.valuedate = $$v
      },
      expression: "valuedate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "状态："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ztId),
      callback: function($$v) {
        _vm.ztId = $$v
      },
      expression: "ztId"
    }
  }, _vm._l((_vm.ztArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("直播间")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "6px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.cjbjzbj()
      }
    }
  }, [_vm._v("创建直播间")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.zbjList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "68px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }], null, false, 811300409)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "房间号",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.wxroomid))]
      }
    }], null, false, 2759293728)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "直播间标题",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.title))]
      }
    }], null, false, 1628289981)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开播时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.livetime))]
      }
    }], null, false, 335833854)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "直播状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.statusname))]
      }
    }], null, false, 278999182)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handlekzt(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-monitor"
        }), _vm._v(" 控制台")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 103),
            expression: "scope.row.status != 103"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handlekbm(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-data-analysis"
        }), _vm._v(" 开播码")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handlefx(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-share"
        }), _vm._v(" 分享")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 102),
            expression: "scope.row.status == 102"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.cjbjzbj(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑\r\n                ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 101),
            expression: "scope.row.status != 101"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.deleteBrand(scope.row, 1)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\r\n                ")])]
      }
    }], null, false, 2337212403)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "text-align": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pagezbjindex,
      "page-size": 10,
      "total": _vm.zbjtotal
    },
    on: {
      "current-change": _vm.changezbjcurrent
    }
  })], 1)])]) : _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "商品名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入商品名称 (20字以内)",
      "maxlength": "20"
    },
    model: {
      value: (_vm.channelName),
      callback: function($$v) {
        _vm.channelName = $$v
      },
      expression: "channelName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("直播商品库")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "6px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addOrEditBrand()
      }
    }
  }, [_vm._v("添加商品")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.zbspkList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "68px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }], null, false, 811300409)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goodsname))]
      }
    }], null, false, 3981461706)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.price))]
      }
    }], null, false, 3949003760)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.statusname))]
      }
    }], null, false, 278999182)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status != 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.cardStatus(scope.row)
            }
          }
        }, [_c('i', {
          class: scope.row.status == 1 ? 'el-icon-circle-close' : 'el-icon-circle-check'
        }), _vm._v("\r\n                  " + _vm._s(scope.row.status == 1 ? "撤销审核" : "提交审核") + "\r\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.status == 0 || scope.row.status == 3) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.addOrEditBrand(scope.row, 1)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑\r\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.addOrEditBrand(scope.row, 2)
            }
          }
        }, [_vm._v("修改价格")]) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 1),
            expression: "scope.row.status != 1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.deleteBrand(scope.row, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\r\n                ")])]
      }
    }], null, false, 2846535434)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "text-align": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pagezbspkindex,
      "page-size": 10,
      "total": _vm.zbspktotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])], 1) : _c('div', {
    staticClass: "main_container"
  }, [_c('h3', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("直播间信息")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "10px 0 0 20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "直播间标题：",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入3-17汉字的标题",
      "maxlength": "17"
    },
    model: {
      value: (_vm.zhibojianbt),
      callback: function($$v) {
        _vm.zhibojianbt = $$v
      },
      expression: "zhibojianbt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "开播时间：",
      "label-width": "100px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%",
      "background": "#fff",
      "border": "1px solid #eee"
    },
    attrs: {
      "type": "datetimerange",
      "align": "right",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "default-time": ['08:00:00', '08:00:00'],
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.changetimeTwo
    },
    model: {
      value: (_vm.kbTime),
      callback: function($$v) {
        _vm.kbTime = $$v
      },
      expression: "kbTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "主播昵称：",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入2-15汉字的昵称",
      "maxlength": "15"
    },
    model: {
      value: (_vm.zhubonc),
      callback: function($$v) {
        _vm.zhubonc = $$v
      },
      expression: "zhubonc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "主播微信号：",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "69%"
    },
    attrs: {
      "placeholder": "请输入主播微信号",
      "maxlength": "50"
    },
    model: {
      value: (_vm.zhubowxh),
      callback: function($$v) {
        _vm.zhubowxh = $$v
      },
      expression: "zhubowxh"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.verificationsuccessOne),
      expression: "verificationsuccessOne"
    }],
    staticClass: "el-input__icon el-icon-success",
    staticStyle: {
      "color": "#5cbb7a"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validationfailedOne),
      expression: "validationfailedOne"
    }],
    staticClass: "el-input__icon el-icon-error",
    staticStyle: {
      "color": "#F56C6C"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.testing(_vm.zhubowxh, 1)
      }
    }
  }, [_vm._v("验证")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "副播微信号：",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "69%"
    },
    attrs: {
      "placeholder": "请输入副播微信号",
      "maxlength": "50"
    },
    model: {
      value: (_vm.fubowxh),
      callback: function($$v) {
        _vm.fubowxh = $$v
      },
      expression: "fubowxh"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.verificationsuccessTwo),
      expression: "verificationsuccessTwo"
    }],
    staticClass: "el-input__icon el-icon-success",
    staticStyle: {
      "color": "#5cbb7a"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validationfailedTwo),
      expression: "validationfailedTwo"
    }],
    staticClass: "el-input__icon el-icon-error",
    staticStyle: {
      "color": "#F56C6C"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.testing(_vm.fubowxh, 2)
      }
    }
  }, [_vm._v("验证")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "-15px"
    },
    attrs: {
      "label": "实名认证码：",
      "label-width": "100px"
    }
  }, [_c('p', {
    staticStyle: {
      "line-height": "0",
      "color": "#F56C6C"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" 主(副)播需要实名认证，请先用微信扫码进行实名认证后，再进行验证。")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": require("../../assets/img/zbsmrz.png")
    }
  })])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "10px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "before-upload": function (file) { return _vm.beforUploadThree(file, 1); }
    }
  }, [(_vm.zbjbjUrl) ? _c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.zbjbjUrl
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.zbjbjUrl) ? _c('i', {
    staticClass: "el-icon-plus upBtn"
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "0"
    }
  }, [_c('b', [_vm._v("直播间背景：")]), _c('br'), _vm._v("建议像素600*1300，大小不超过 3M，格式JPG")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "10px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "before-upload": function (file) { return _vm.beforUploadThree(file, 2); }
    }
  }, [(_vm.fxtpUrl) ? _c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.fxtpUrl
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.fxtpUrl) ? _c('i', {
    staticClass: "el-icon-plus upBtn"
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "0"
    }
  }, [_c('b', [_vm._v("分享图片：")]), _c('br'), _vm._v("建议像素800*640，大小不超过1M,格式JPG")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "10px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "before-upload": function (file) { return _vm.beforUploadThree(file, 3); }
    }
  }, [(_vm.sltpUrl) ? _c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.sltpUrl
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.sltpUrl) ? _c('i', {
    staticClass: "el-icon-plus upBtn"
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "0"
    }
  }, [_c('b', [_vm._v("收录图片：")]), _c('br'), _vm._v("建议像素800*800，大小不超过100KB,格式JPG")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('b', [_vm._v("直播间功能：")]), _c('span', [_vm._v("以下五个功能无法在开播后设置开启或关闭")])]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.checkedpl),
      callback: function($$v) {
        _vm.checkedpl = $$v
      },
      expression: "checkedpl"
    }
  }, [_vm._v("评论")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.checkedfx),
      callback: function($$v) {
        _vm.checkedfx = $$v
      },
      expression: "checkedfx"
    }
  }, [_vm._v("分享")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.checkeddz),
      callback: function($$v) {
        _vm.checkeddz = $$v
      },
      expression: "checkeddz"
    }
  }, [_vm._v("点赞")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.checkedsphj),
      callback: function($$v) {
        _vm.checkedsphj = $$v
      },
      expression: "checkedsphj"
    }
  }, [_vm._v("商品货架")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.checkedhf),
      callback: function($$v) {
        _vm.checkedhf = $$v
      },
      expression: "checkedhf"
    }
  }, [_vm._v("回放")])], 1), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvasa",
      "hidden": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshowzbsp),
      expression: "isshowzbsp"
    }]
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "padding": "0 20px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "height": "fit-content",
      "margin-top": "5px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.selectproduct()
      }
    }
  }, [_vm._v("选择商品")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticClass: "invoice_tab",
    staticStyle: {
      "height": "auto",
      "max-height": "500px"
    },
    attrs: {
      "data": _vm.zbcommodityList.slice((_vm.data.pageNum - 1) * _vm.data.pageSize, _vm.data.pageNum * _vm.data.pageSize),
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "68px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goodsname))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.price))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.shanchusp(scope.$index, _vm.zbcommodityList)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "text-align": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.data.pageNum,
      "page-size": _vm.data.pageSize,
      "total": _vm.zbcommodityList.length
    },
    on: {
      "current-change": _vm.handlegdChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.data, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.data, "pageNum", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "10px 0 20px 0"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.handlezbj(2)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loadingBut
    },
    on: {
      "click": function($event) {
        return _vm.handlezbj(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.commodity,
      "visible": _vm.isToExamine,
      "center": true,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeDis),
      expression: "seeDis"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "选择商品 :",
      "label-width": "80px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changesp
    },
    model: {
      value: (_vm.stateId),
      callback: function($$v) {
        _vm.stateId = $$v
      },
      expression: "stateId"
    }
  }, _vm._l((_vm.statearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.goodsname,
        "value": item.shopgoodsid
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeDis),
      expression: "seeDis"
    }],
    staticStyle: {
      "width": "80%",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "商品封面 :",
      "label-width": "80px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "before-upload": function (file) { return _vm.beforUploadThree(file, 4); }
    }
  }, [(_vm.spfmUrl) ? _c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.spfmUrl
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.spfmUrl) ? _c('i', {
    staticClass: "el-icon-plus upBtn"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("建议尺寸：300*300，支持的图片格式：jpg、png。")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvasa",
      "hidden": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeDis),
      expression: "seeDis"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "商品名称 :",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品名称 (14字以内)",
      "maxlength": "14"
    },
    model: {
      value: (_vm.brandName),
      callback: function($$v) {
        _vm.brandName = $$v
      },
      expression: "brandName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格形式 :"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.resource),
      callback: function($$v) {
        _vm.resource = $$v
      },
      expression: "resource"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("一口价")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("价格区间")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("显示折扣价")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resource == 1),
      expression: "resource == 1"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "价格 :",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "maxlength": "10",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.anwser),
      callback: function($$v) {
        _vm.anwser = $$v
      },
      expression: "anwser"
    }
  }, [_c('i', {
    staticStyle: {
      "font-style": "normal",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resource == 2),
      expression: "resource == 2"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "价格区间 :",
      "label-width": "80px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "maxlength": "10",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.jgqjOne),
      callback: function($$v) {
        _vm.jgqjOne = $$v
      },
      expression: "jgqjOne"
    }
  }, [_c('i', {
    staticStyle: {
      "font-style": "normal",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "maxlength": "10",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.jgqjTwo),
      callback: function($$v) {
        _vm.jgqjTwo = $$v
      },
      expression: "jgqjTwo"
    }
  }, [_c('i', {
    staticStyle: {
      "font-style": "normal",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resource == 3),
      expression: "resource == 3"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "折扣区间 :",
      "label-width": "80px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "市场价",
      "maxlength": "10",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.zkqjOne),
      callback: function($$v) {
        _vm.zkqjOne = $$v
      },
      expression: "zkqjOne"
    }
  }, [_c('i', {
    staticStyle: {
      "font-style": "normal",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "折扣价",
      "maxlength": "10",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.zkqjTwo),
      callback: function($$v) {
        _vm.zkqjTwo = $$v
      },
      expression: "zkqjTwo"
    }
  }, [_c('i', {
    staticStyle: {
      "font-style": "normal",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1)], 1)], 1), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeDis),
      expression: "seeDis"
    }],
    model: {
      value: (_vm.checkedsp),
      callback: function($$v) {
        _vm.checkedsp = $$v
      },
      expression: "checkedsp"
    }
  }, [_vm._v("同时提交商品审核")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isToExamine = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择商品",
      "visible": _vm.shangpin,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.shangpin = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "商品名称："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.searchsp),
      callback: function($$v) {
        _vm.searchsp = $$v
      },
      expression: "searchsp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.finddes()
      }
    }
  }, [_vm._v("查 询")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "max-height": "30vh",
      "overflow-y": "scroll"
    },
    attrs: {
      "data": _vm.spList,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleselection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goodsname",
      "label": "商品名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "商品价格(元)",
      "align": "center"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.shangpin = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.handlesp()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "开播码",
      "visible": _vm.kaiboma,
      "center": true,
      "width": "20%"
    },
    on: {
      "update:visible": function($event) {
        _vm.kaiboma = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "src": _vm.kbmUrl
    }
  }), _vm._v(" "), _c('div', [_c('b', [_vm._v("小程序开播码")])]), _vm._v(" "), _c('p', [_vm._v("微信扫码打开主播小程序")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handDown(_vm.kbmUrl)
      }
    }
  }, [_vm._v("保存开播码")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("开播码永久有效")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "分享",
      "visible": _vm.fenxiang,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.fenxiang = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding": "10px 0 10px 10px",
      "background": "#F7F7F7"
    },
    attrs: {
      "span": 11
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": 12
    }
  }, [_c('b', [_vm._v("直播间分享海报")]), _vm._v(" "), _c('p', [_vm._v("小程序码不带参数")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handDown(_vm.fxhb)
      }
    }
  }, [_vm._v("保存图片")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": _vm.fxhb
    }
  })])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "10px 0 10px 10px",
      "background": "#F7F7F7"
    },
    attrs: {
      "span": 11
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": 12
    }
  }, [_c('b', [_vm._v("直播间小程序码")]), _vm._v(" "), _c('p', [_vm._v("小程序码不带参数")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handDown(_vm.fxewmandkbm)
      }
    }
  }, [_vm._v("保存图片")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": _vm.fxewmandkbm
    }
  })])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片剪裁",
      "visible": _vm.cropping,
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cropping = $event
      }
    }
  }, [_c('div', {
    staticClass: "cropper-content"
  }, [_c('div', {
    staticClass: "cropper"
  }, [_c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.option.size,
      "fixedBox": _vm.option.fixedBox,
      "outputType": _vm.option.outputType,
      "full": _vm.option.full,
      "canMove": _vm.option.canMove,
      "infoTrue": _vm.option.infoTrue,
      "canMoveBox": _vm.option.canMoveBox,
      "original": _vm.option.original,
      "autoCrop": _vm.option.autoCrop,
      "info": true,
      "fixed": _vm.option.fixed,
      "fixedNumber": _vm.option.fixedNumber,
      "centerBox": _vm.option.centerBox,
      "autoCropWidth": _vm.option.autoCropWidth,
      "autoCropHeight": _vm.option.autoCropHeight
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cropping = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("确认")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "请选择店铺",
      "visible": _vm.dialogVisibleadd,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleadd = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺"
    },
    model: {
      value: (_vm.bbid),
      callback: function($$v) {
        _vm.bbid = $$v
      },
      expression: "bbid"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('my-popUp', {
    ref: "dialog",
    attrs: {
      "content": "重要信息，你确定要删除吗？"
    },
    on: {
      "ok": _vm.onOk
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("直播商品")]), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("温馨提示：直播间如需配置商品，只能选择商品库审核通过的商品。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a8a176d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/operationManagement/livebroadcast.vue
// module id = 1685
// module chunks = 3